import React from 'react';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { INLINES } from '@contentful/rich-text-types';
import HyperLink from 'components/Core/HyperLink';
import { reduceContentValues } from 'utils/text';

const options = {
  renderNode: {
    [INLINES.HYPERLINK]: (node) => {
      return (
        <HyperLink href={node.data.uri} target="_blank">
          {reduceContentValues(node?.content)}
        </HyperLink>
      );
    },
  },
};

const TermsText = ({ termsText, formStep }) => {
  return termsText?.raw ? (
    renderRichText(termsText, options)
  ) : (
    <p>
      By entering your information above and clicking{' '}
      {!formStep ? 'this ' : formStep === 0 ? `the "Agree and Get Started" ` : `the "Submit" `}
      button, you agree to our{' '}
      <HyperLink href="/legal/terms-of-use" target="_blank">
        Terms of Use
      </HyperLink>{' '}
      and{' '}
      <HyperLink href="/legal/privacy-policy" target="_blank">
        Privacy Policy
      </HyperLink>
      , and that we may contact you, by SMS, at the phone number and email address you provide in
      this form in accordance with our Terms of Use.
    </p>
  );
};

export default TermsText;
